import { TFunction } from '@util/types';

export interface DevelopmentDrawerItem {
  header: string;
  listings?: BuildingOverview[];
}

interface BuildingOverview {
  header: string;
  content?: string[];
}

const formatDate = (availabilityBy: string): string => {
  const date = new Date(availabilityBy);

  if (isNaN(date.getTime())) return availabilityBy; // Fallback if parsing fails

  // Format as MM/DD/YYYY
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

const mapDrawerData = (listingData, t: TFunction) => {
  const drawerDataCollected: DevelopmentDrawerItem[] = [];
  const buildingOverviewData: BuildingOverview[] = [];

  const propertyType =
    listingData.evaMetadata?.PropertySubType || listingData.PropertySubType || null;
  if (propertyType) {
    buildingOverviewData.push({
      header: t('Property Type'),
      content: [propertyType],
    });
  }
  const parkingFeatures =
    listingData.evaMetadata?.ParkingFeatures || listingData.ParkingFeatures || null;

  const formattedParkingFeatures = parkingFeatures?.join(', ');

  if (parkingFeatures) {
    buildingOverviewData.push({
      header: t('Parking Features'),
      content: [formattedParkingFeatures],
    });
  }
  const buildingEra =
    listingData.evaMetadata?.DevelopmentData?.BuildingStatus ||
    listingData.DevelopmentData?.BuildingStatus ||
    null;
  if (buildingEra) {
    buildingOverviewData.push({
      header: t('Building Era'),
      content: [buildingEra],
    });
  }
  const access =
    listingData.evaMetadata?.DevelopmentData?.Elevator ||
    listingData.DevelopmentData?.Elevator ||
    null;
  buildingOverviewData.push({
    header: t('Access'),
    content: access && 'Elevator',
  });
  const buildingSize =
    listingData.evaMetadata?.DevelopmentData?.BuildingSize ||
    listingData.DevelopmentData?.BuildingSize ||
    null;
  if (buildingSize) {
    buildingOverviewData.push({
      header: t('Building Size'),
      content: [buildingSize],
    });
  }
  const garageOnSite = listingData.evaMetadata?.GarageYN || listingData.GarageYN || null;
  if (garageOnSite) {
    buildingOverviewData.push({
      header: t('Garage On Site'),
      content: [garageOnSite ? 'Yes' : 'No'],
    });
  }
  const availabilityBy =
    listingData.evaMetadata?.DevelopmentData?.AvailabilityBy ||
    listingData.DevelopmentData?.AvailabilityBy ||
    null;
  if (listingData.YearBuilt) {
    buildingOverviewData.push({
      header: t('Year Built'),
      content: [listingData.YearBuilt],
    });
  }

  const serviceLevel =
    listingData.evaMetadata?.DevelopmentData?.ServiceLevel ||
    listingData.DevelopmentData?.ServiceLevel ||
    null;
  if (serviceLevel) {
    buildingOverviewData.push({
      header: t('Service Level'),
      content: [serviceLevel],
    });
  }

  const floors = listingData.evaMetadata?.DevelopmentData?.NumberOfFloors || null;
  if (floors) {
    buildingOverviewData.push({
      header: t('Floors'),
      content: [floors],
    });
  }

  if (listingData.BuilderName) {
    buildingOverviewData.push({
      header: t('Builder/Developer'),
      content: [listingData.BuilderName],
    });
  }
  const numOfResidences =
    listingData.DevelopmentData?.NumberOfResidences ||
    listingData.evaMetadata?.DevelopmentData?.NumberOfResidences ||
    null;

  if (numOfResidences) {
    buildingOverviewData.push({
      header: t('# of Residences'),
      content: [numOfResidences],
    });
  }

  if (availabilityBy) {
    buildingOverviewData.push({
      header: t('Availability By'),
      content: [formatDate(availabilityBy)],
    });
  }

  buildingOverviewData.length > 0
    ? drawerDataCollected.push({
        header: t('Building Overview'),
        listings: [...buildingOverviewData],
      })
    : null;

  // listingData.ExteriorFeatures
  //   ? drawerDataCollected.push({
  //       header: 'Exterior Features',
  //       list: listingData.ExteriorFeatures,
  //     })
  //   : null;

  // listingData.Utilities
  //   ? drawerDataCollected.push({
  //       header: 'Utilities',
  //       list: listingData.Utilities,
  //     })
  //   : null;

  return drawerDataCollected;
};

export default mapDrawerData;
